import { http } from './base/http';
import type { TemplateTag } from './types/tag';
import type { TemplateDetails, TemplateListResponse, TemplateQuery } from './types/template';

export const TemplateAPIs = {
    async getTemplateList(query: TemplateQuery): Promise<TemplateListResponse> {
        return await http.get<TemplateListResponse>('/templates', query as Record<string, unknown>);
    },

    async createTemplate(template: {
        name: string;
        latest_version: { variants: { svg_file: number; name: string }[] };
    }): Promise<Record<string, unknown>> {
        return await http.post('/templates', template);
    },

    async getTemplate(id: number): Promise<TemplateDetails> {
        return await http.get<TemplateDetails>(`/templates/${id}`);
    },

    async getTemplateTags(templateId: number): Promise<TemplateTag[]> {
        return await http.get<TemplateTag[]>(`/templates/${templateId}/tags`);
    },

    async shareTemplate(templateId: number, email: string): Promise<Record<string, unknown>> {
        return await http.post(`/templates/${templateId}/share`, { email });
    },
};
